import { render, staticRenderFns } from "./WidgetsForm.vue?vue&type=template&id=509cdbaa"
import script from "./WidgetsForm.vue?vue&type=script&lang=js"
export * from "./WidgetsForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetsForm.vue?vue&type=style&index=0&id=509cdbaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports